import { IconProps } from "./IconProps";

export const DoorExitIcon24 = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8611 10.75V10.7611M0.75 20.75H20.75M2.97222 20.75V2.97222C2.97222 2.38285 3.20635 1.81762 3.6231 1.40087C4.03984 0.984126 4.60507 0.75 5.19444 0.75H13.5278M16.3056 12.4167V20.75M12.9722 5.19444H20.75M20.75 5.19444L17.4167 1.86111M20.75 5.19444L17.4167 8.52778"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
